import { useNavigate } from "react-router-dom"
import Button from "../Components/Button"

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col justify-between bg-background">
      <div className="mx-auto w-full max-w-5xl p-12">
        <img className="mb-16 w-[300px]" src="/logo.png" alt="Encircled Logo" />

        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-8">
            <h1 className="mb-4 text-6xl font-bold text-brand">404</h1>
            <h2 className="mb-2 text-2xl font-bold text-black">Page Not Found</h2>
            <p className="text-lg text-gray-600">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="flex gap-4">
            <Button onClick={() => navigate(-1)} variant="secondary-outline">
              Go Back
            </Button>
            <Button onClick={() => navigate("/")}>
              Go Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
